(function () {
  if (window.jkProductDesignInitialized) return;
  window.jkProductDesignInitialized = true;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var btn = document.getElementById("jk-start-design");
    if (!btn) return;

    var variants = Array.isArray(window.jkProductVariants) ? window.jkProductVariants : [];
    var productHandle = window.jkProductHandle || "";
    var productId = window.jkCurrentProductId || "";

    var selectionCache = {
      variantId: "",
      slots: 0,
      updatedAt: 0,
      source: ""
    };

    function now() {
      return Date.now();
    }

    function extractNumbers(text) {
      var matches = String(text || "").match(/\d+/g);
      if (!matches) return [];
      return matches
        .map(function (m) { return parseInt(m, 10); })
        .filter(function (n) { return !isNaN(n) && n > 0; });
    }

    function extractFirstNumber(text) {
      var nums = extractNumbers(text);
      return nums.length ? nums[0] : 0;
    }

    function unique(arr) {
      return Array.from(new Set((arr || []).filter(Boolean)));
    }

    function getVariantById(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      }) || null;
    }

    function getVariantSlotCount(variant) {
      if (!variant) return 0;

      var pool = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.name,
        variant.public_title,
        variant.sku
      ];

      for (var i = 0; i < pool.length; i++) {
        var n = extractFirstNumber(pool[i]);
        if (n > 0) return n;
      }

      return 0;
    }

    function findVariantBySlotCount(slotCount) {
      if (!slotCount) return null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (getVariantSlotCount(variant) === slotCount) {
          return variant;
        }
      }

      return null;
    }

    function getUrlVariantId() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get("variant") || "";
      } catch (e) {
        return "";
      }
    }

    function getHiddenVariantId() {
      var selectors = [
        'form[action*="/cart/add"] input[name="id"]',
        'product-form input[name="id"]',
        '.product-form input[name="id"]',
        'input[name="id"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.value) return String(el.value);
      }

      return "";
    }

    function setCache(variantId, slots, source) {
      if (!variantId || !slots) return;
      selectionCache.variantId = String(variantId);
      selectionCache.slots = parseInt(slots, 10) || 0;
      selectionCache.updatedAt = now();
      selectionCache.source = source || "";
    }

    function getCacheFresh() {
      if (!selectionCache.variantId) return null;
      if (now() - selectionCache.updatedAt > 15000) return null;

      return {
        variantId: selectionCache.variantId,
        slots: selectionCache.slots,
        source: selectionCache.source || "cache"
      };
    }

    function resolveFromHiddenInput() {
      var hiddenVariantId = getHiddenVariantId();
      if (!hiddenVariantId) return null;

      var variant = getVariantById(hiddenVariantId);
      if (!variant) return null;

      var slots = getVariantSlotCount(variant);
      if (!slots) return null;

      return {
        variantId: String(hiddenVariantId),
        slots: slots,
        source: "hidden-input"
      };
    }

    function resolveFromUrl() {
      var urlVariantId = getUrlVariantId();
      if (!urlVariantId) return null;

      var variant = getVariantById(urlVariantId);
      if (!variant) return null;

      var slots = getVariantSlotCount(variant);
      if (!slots) return null;

      return {
        variantId: String(urlVariantId),
        slots: slots,
        source: "url"
      };
    }

    function resolveFromFirstAvailableVariant() {
      if (!variants.length) return null;

      var firstAvailable = variants.find(function (variant) {
        return variant && variant.available !== false;
      }) || variants[0] || null;

      if (!firstAvailable || !firstAvailable.id) return null;

      var slots = getVariantSlotCount(firstAvailable);
      if (!slots) return null;

      return {
        variantId: String(firstAvailable.id),
        slots: slots,
        source: "first-available-fallback"
      };
    }

    function resolveBestSelection() {
      var cached = getCacheFresh();
      if (cached) return cached;

      var hidden = resolveFromHiddenInput();
      if (hidden) {
        setCache(hidden.variantId, hidden.slots, hidden.source);
        return hidden;
      }

      var fromUrl = resolveFromUrl();
      if (fromUrl) {
        setCache(fromUrl.variantId, fromUrl.slots, fromUrl.source);
        return fromUrl;
      }

      /*
        Son güvenli fallback:
        Sayfada henüz görünür bir adet seçimi yapılmadıysa veya mobilde
        native varyant kontrolü gizliyse, ürünün ilk kullanılabilir
        varyantını varsayılan seçim olarak kullan.

        Mevcut seçim sistemi değişmez:
        - Kullanıcı bir adet seçmişse o seçim kullanılır.
        - Hidden input / URL varyantı varsa onlar önceliklidir.
        - Sadece hiçbir seçim çözülemiyorsa bu fallback devreye girer.
      */
      var firstAvailable = resolveFromFirstAvailableVariant();
      if (firstAvailable) {
        setCache(firstAvailable.variantId, firstAvailable.slots, firstAvailable.source);
        return firstAvailable;
      }

      return {
        variantId: "",
        slots: 0,
        source: "none"
      };
    }

    function captureSlotFromText(text, source) {
      var slotCount = extractFirstNumber(text);
      if (!slotCount) return false;

      var matchedVariant = findVariantBySlotCount(slotCount);
      if (!matchedVariant) return false;

      setCache(String(matchedVariant.id), slotCount, source);
      return true;
    }

    function captureFromElement(el) {
      if (!el) return false;

      var texts = [];

      if (el.value) texts.push(el.value);
      if (el.textContent) texts.push(el.textContent);
      if (el.innerText) texts.push(el.innerText);
      if (el.getAttribute && el.getAttribute("aria-label")) texts.push(el.getAttribute("aria-label"));
      if (el.getAttribute && el.getAttribute("title")) texts.push(el.getAttribute("title"));
      if (el.getAttribute && el.getAttribute("data-value")) texts.push(el.getAttribute("data-value"));
      if (el.getAttribute && el.getAttribute("data-option-value")) texts.push(el.getAttribute("data-option-value"));

      if (el.id && window.CSS && CSS.escape) {
        var label = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
        if (label) {
          texts.push(label.textContent || "");
          texts.push(label.innerText || "");
        }
      }

      var parentLabel = el.closest ? el.closest("label") : null;
      if (parentLabel) {
        texts.push(parentLabel.textContent || "");
        texts.push(parentLabel.innerText || "");
      }

      texts = unique(
        texts.map(function (t) {
          return String(t || "").trim();
        }).filter(Boolean)
      );

      for (var i = 0; i < texts.length; i++) {
        if (captureSlotFromText(texts[i], "ui-direct")) return true;
      }

      return false;
    }

    function captureFromCurrentlyCheckedControls() {
      var found = false;

      document.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        if (!found && captureFromElement(radio)) found = true;
      });

      if (found) return true;

      document.querySelectorAll("select").forEach(function (select) {
        if (found) return;
        var option = select.options[select.selectedIndex];
        if (option && captureFromElement(option)) found = true;
      });

      return found;
    }

    function syncFromHiddenInputSoon() {
      [0, 80, 180].forEach(function (delay) {
        setTimeout(function () {
          var hidden = resolveFromHiddenInput();
          if (hidden) {
            setCache(hidden.variantId, hidden.slots, "hidden-input-sync");
          }
        }, delay);
      });
    }

    function makeDesignKey() {
      return [
        "jk",
        productHandle || "product",
        Date.now(),
        Math.random().toString(36).slice(2, 8)
      ].join("_");
    }

    function openEditor() {
      var resolved = resolveBestSelection();
      var variantId = resolved.variantId;
      var slots = Math.max(1, parseInt(resolved.slots || 0, 10) || 1);

      if (!variantId) {
        alert("Lütfen önce adet seçin.");
        return;
      }

      // 🔥 EN DOĞRU BORDER OKUMA - SENİN HTML YAPINA GÖRE
      var border = "";

      // 1. Öncelik: custom border picker
      var activeBtn = document.querySelector('.jk-border-picker[data-option-name*="Kenarlık"] .jk-border-picker__item.is-active');
      if (activeBtn) {
        border = activeBtn.getAttribute("data-border-value") || activeBtn.textContent.trim();
      }

      // 2. Fallback: aria-pressed=true olan custom button
      if (!border) {
        var pressedBtn = document.querySelector('.jk-border-picker[data-option-name*="Kenarlık"] .jk-border-picker__item[aria-pressed="true"]');
        if (pressedBtn) {
          border = pressedBtn.getAttribute("data-border-value") || pressedBtn.textContent.trim();
        }
      }

      // 3. Son fallback: variant title
      if (!border) {
        var variant = getVariantById(variantId);
        if (variant && variant.title) {
          var parts = String(variant.title).split("/");
          if (parts.length > 1) {
            border = parts[1].trim();
          }
        }
      }

      var designKey = makeDesignKey();
      var designRef = designKey.slice(-6).toUpperCase();

      var editorUrl =
        "/pages/editor" +
        "?variant_id=" + encodeURIComponent(variantId) +
        "&slots=" + encodeURIComponent(slots) +
        "&product_handle=" + encodeURIComponent(productHandle) +
        "&product_id=" + encodeURIComponent(productId) +
        "&design_key=" + encodeURIComponent(designKey) +
        "&design_ref=" + encodeURIComponent(designRef) +
        "&border=" + encodeURIComponent(border) +
        "&t=" + Date.now();

      window.location.href = editorUrl;
    }

    btn.addEventListener("click", function () {
      btn.classList.add("is-loading");
      openEditor();
      setTimeout(function () {
        btn.classList.remove("is-loading");
      }, 250);
    });

    document.addEventListener("change", function (event) {
      captureFromElement(event.target);
      captureFromCurrentlyCheckedControls();
      syncFromHiddenInputSoon();
    }, true);

    document.addEventListener("input", function (event) {
      captureFromElement(event.target);
      captureFromCurrentlyCheckedControls();
      syncFromHiddenInputSoon();
    }, true);

    document.addEventListener("click", function (event) {
      captureFromElement(event.target);
      syncFromHiddenInputSoon();
    }, true);

    var observer = new MutationObserver(function () {
      syncFromHiddenInputSoon();
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["value", "checked", "class", "aria-selected", "aria-pressed"]
    });

    captureFromCurrentlyCheckedControls();
    syncFromHiddenInputSoon();
  });
})();